import React, { useMemo } from 'react';
import { Box } from '@components/Box';
import { HorizontalSlider } from '@sections/shared/HorizontalSlider';
import { ShopRegistryDepartment } from './ShopRegistryDepartment';
import { StyledSliderWrapper } from './ShopRegistrySection.styles';

interface DepartmentDataProps {
  id: string;
  title: string;
  image: string;
  link: string;
}

interface ShopRegistrySectionProps {
  shopTitle: string;
  idPrefix: string;
  departmentsData: DepartmentDataProps[];
}

export const ShopRegistrySection = ({ shopTitle, idPrefix, departmentsData }: ShopRegistrySectionProps) => {
  const departmentitems = useMemo(
    () =>
      departmentsData?.map(item => ({
        id: item?.id,
        item: <ShopRegistryDepartment image={item.image} />,
      })),
    [departmentsData]
  );
  return (
    <Box as="section" id={`${idPrefix}ShopRegistrySection`} paddingX={[7, 0]}>
      <StyledSliderWrapper marginTop={9} paddingTop={[1, 5]}>
        <HorizontalSlider title={shopTitle} titlePadding={[0, 9]} items={departmentitems} />
      </StyledSliderWrapper>
    </Box>
  );
};
